/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// sounds
import SoundAlert from "./sounds/alert_funk.mp3";
import SoundSuccess from "./sounds/success_ding.mp3";

class SoundUtils {
  static _private_playSound(sound) {
    const newSound = new Audio(sound);
    newSound.play().catch(() => {
      // Insert here to know if
      //sound has failed to play
    });
  }

  static alert() {
    SoundUtils._private_playSound(SoundAlert);
  }

  static success() {
    SoundUtils._private_playSound(SoundSuccess);
  }
}
export default SoundUtils;
